import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Observable, ReplaySubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ProductionDatePayload } from '../types/production-date-payload.type';
import { ProductionDateLotViewType } from '../types/production-date-lot-view.type';
import { AutoLotView } from '../../../../const';

@Injectable()
export class CheckProductionDatePayloadService {
  private lot$ = new ReplaySubject<ProductionDateLotViewType | null>(1);

  get payload$(): Observable<ProductionDatePayload> {
    return this.lot$.pipe(
      filter((lot) => Boolean(lot)),
      map((lot) => this.compilePayload(lot)),
    );
  }

  emit(lot: ProductionDateLotViewType): void {
    this.lot$.next(lot);
  }

  compilePayload(lot: ProductionDateLotViewType | null): ProductionDatePayload {
    const excludePayloadFields = ['year', 'month', 'day', 'vin'];
    const payload = lot?.productionDatePayload?.epc_export ?? {};
    let newPayload = {
      date: lot?.productionDate
        ? DateTime.fromISO(lot.productionDate).toFormat('yyyy-MM-dd')
        : undefined,
      ...payload,
    } as { [key: string]: string };

    if (lot.vin && lot.productionDate) {
      newPayload = {
        vincode: lot.vin,
        ...newPayload,
      };
    }

    const kawasakiYear = (lot as AutoLotView)?.kawasakiLotData?.production_year;
    if (kawasakiYear) {
      newPayload = {
        ...newPayload,
        production_year: kawasakiYear,
      };
    }

    return Object.entries(newPayload)
      .map((pair) => ({ key: pair[0], value: pair[1] }))
      .filter((pair) => !excludePayloadFields.includes(pair.key))
      .filter((pair) => Boolean(pair.value));
  }
}
